//enums
import {TABLES_MEALS} from '@/utils/enums';

export const TABLE = 'Table';
export const TABLE_NAME = 'Table name';
export const TABLE_NAME_CAMEL = 'tableName';
export const TICKET = 'Ticket';
export const TICKETS = 'tickets';
export const TYPE_OF_SEAT = 'Type of seat';
export const SEAT_TYPE = 'Seat type';
export const SEAT_TYPE_CAMEL = 'seatType';
export const TABLE_PURCHASER = 'Purchaser';
export const PURCHASER = 'purchaser';
export const PRICE = 'Price';
export const AMOUNT = 'Amount';
export const TOTAL = 'Total';
export const SUBTOTAL = 'Subtotal';
export const ALL_ATTENDEES = 'All Attendees';
export const ALL = 'All';
export const VIP_STATUS = 'VIP status';
export const DOLLAR = '$';
export const ASC = 'asc';
export const DESC = 'desc';
export const HASH = ' #';
export const DOWNLOAD_CSV = 'Download .csv';
export const NO_DATA_FOUND = 'No data found';
export const PENDING = 'Pending';
export const PAID = 'Paid';
export const BID = 'bid';
export const BIDS = 'Bids';
export const CONTRIBUTIONS = 'Contributions';
export const PROFILE = 'Profile';
export const FIRST_NAME = 'First name';
export const FIRST_NAME_CAMEL = 'firstName';
export const LAST_NAME = 'Last name';
export const LAST_NAME_CAMEL = 'lastName';
export const EMAIL = 'Email';
export const PHONE_NUMBER = 'Phone number';
export const PHONE = 'Phone';
export const MEAL = 'Meal';
export const ADDRESS = 'address';
export const CITY = 'city';
export const STATE = 'state';
export const ZIP = 'zip';
export const PAY_STATUS_CAMEL = 'payStatus';
export const TABLE_NUMBER_CAMEL = 'tableNumber';
export const ITEM = 'Item';
export const VALUE = 'Value';
export const VALUE_LOWER = 'value';
export const MIN_BID = 'Min bid';
export const MIN_BID_CAMEL = 'minBid';
export const BID_INCREMENT = 'Bid increment';
export const BID_INCREMENT_CAMEL = 'bidIncrement';
export const BUY_NOW_PRICE = 'Buy now price';
export const BUY_NOW_PRICE_CAMEL = 'buyNowPrice';
export const CONTACT_PHONE = 'Contact phone';
export const BID_ID_CAMEL = 'bidId';
export const BID_NUMBER_CAMEL = 'bidNumber';
export const ADD_TICKET = 'Add Ticket';
export const ADD_TICKETS = 'Add Tickets';
export const TICKETS_TIERS = 'Tickets tiers';
export const TICKETS_TIER = 'Tickets tier';
export const PAY_STATUS = 'Payment status';
export const SEATS = 'Seats';
export const AVAILABLE_TICKETS = 'Seats available';
export const TICKETS_INFO = 'Tickets info';
export const ATTENDEES_INFO = "Attendees' Info";
export const PAYMENT = 'Payment';
export const YOUR_ORDER = 'Your order';
export const CHOSE_PAYMENT_OPTION = 'Choose payment option:';
export const PAY_WITH_CREDIT_CARD = 'Pay with Credit Card';
export const PAID_BY_CASH_ORE_CHECK = 'Paid by Cash or Check';
export const INVOICE_LATER = 'Invoice Later';
export const COVER_FEE = 'Cover fee';
export const COVER_FEE_TEXT =
	"When you cover our transaction costs, you're covering both our processing and donation platform costs.";
export const VIP = 'Vip';
export const IS_VIP = 'isVIP';
export const CREATE_ITEM = 'Create item';
export const ADD_NEW_ITEM = 'Add new item';
export const ADD_ITEM = 'Add item';
export const EDIT_ITEM = 'Edit item';
export const ALL_TICKETS_TIERS = 'All Tickets Tiers';
export const CATEGORIES = 'Categories';
export const CATEGORY = 'category';
export const ALL_CATEGORIES = 'All Categories';
export const ALL_ITEMS = 'All Items';
export const ALL_BIDS = 'All Bids';
export const ACTIVE = 'Active';
export const CLOSED = 'Closed';
export const ITEM_DETAILS = 'Item details';
export const WINNING_BID = 'Winning bid';
export const WINNER = 'Winner';
export const UPDATE_FROM_CONTACT_LIST = 'Update from Contacts';
export const IMPORT_CONTACT_LIST = 'Import Contact List';
export const EVENT_ID = 'eventId';
export const ORGANIZATION_ID = 'organizationId';
export const PERSONAL_INFO = 'Personal Info';
export const ADDRESS_INFO = 'Address Info';
export const OPTIONAL = 'optional';
export const BLOCK_ACCOUNT = 'Block Account';
export const BLOCK_USER = 'Block User';
export const RESTORE_ACCOUNT = 'Restore Account';
export const ORGANIZATION_INFO = 'Organization Info';
export const TEAM_MEMBERS = 'Team Members';
export const EVENTS = 'Events';
export const ATTENDEE = 'Attendee';
export const ITEM_WITHOUT_BIDS = 'Item without bids';
export const AUCTION_REMAINING = 'Auction remaining';
export const WIN_BID = 'Win bid';
export const WINNER_NAME = 'Winner name';
export const BIDDER_ID = 'bidder';
export const NOTIFY_WINNERS = 'Notify Winners';
export const PATRON_DETAILS = 'Patron Details';
export const TABLE_DETAILS = 'Table Details';
export const NAME = 'Name';
export const STATUS = 'Status';
export const PAYMENT_PENDING = 'Payment pending';
export const NOT_CHECKED_IN = 'Not checked in';
export const TICKET_TYPE = 'Ticket type';
export const QUANTITY = 'Quantity';
export const TABLE_NAME_TEXT = 'e.g. VIP Table, General Admission etc ';
export const EMAIL_TICKET = 'Email Ticket';
export const BANK_TRANSFER = 'Pay with Bank Transfer';
export const NO_CONTRIBUTION = 'No contribution';

export const mealsSelectOptions = [
	{id: TABLES_MEALS.VEGETARIAN, name: TABLES_MEALS.VEGETARIAN},
	{id: TABLES_MEALS.VEGAN, name: TABLES_MEALS.VEGAN},
	{id: TABLES_MEALS.GLUTEN_FREE, name: 'Gluten Free'},
	{id: TABLES_MEALS.KOSHER, name: TABLES_MEALS.KOSHER},
	{id: TABLES_MEALS.DAIRY_FREE, name: 'Dairy Free'},
	{id: TABLES_MEALS.NUT_ALLERGY, name: 'Nut Allergy'},
];
